module.exports = "/packs/007-b96ec886a806e782cea90dbd79b86971.jpg";